/* THE SILLAGE STUDIO — Build-Your-Box combo basket
 * Lets a customer pick exactly N perfumes for a 2X / 4X / 10X pack, then adds
 * the SINGLE combo product to the cart once (at the combo price) with the chosen
 * perfume names carried as line-item properties. Individual perfumes are never
 * added as separate line items. No dependencies. */
(function () {
  'use strict';

  function boot() {
    var root = document.querySelector('[data-combo-builder]');
    if (!root) return;

    var cfgEl = root.querySelector('#tss-combo-config');
    var dataEl = root.querySelector('#tss-combo-data');
    if (!cfgEl || !dataEl) return;

    var MODES, PRODUCTS;
    try {
      MODES = JSON.parse(cfgEl.textContent);
      PRODUCTS = JSON.parse(dataEl.textContent);
    } catch (e) { return; }

    if (!PRODUCTS.length) return;

    // ---- DOM refs -------------------------------------------------------
    var modal = root.querySelector('[data-combo-modal]');
    var titleEl = root.querySelector('[data-combo-title]');
    var subEl = root.querySelector('[data-combo-sub]');
    var gridEl = root.querySelector('[data-combo-grid]');
    var filterEl = root.querySelector('[data-combo-filters]');
    var searchEl = root.querySelector('[data-combo-search]');
    var countEl = root.querySelector('[data-combo-count]');
    var priceLineEl = root.querySelector('[data-combo-priceline]');
    var addBtn = root.querySelector('[data-combo-add]');
    var errEl = root.querySelector('[data-combo-error]');
    var emptyEl = root.querySelector('[data-combo-empty]');

    var state = { mode: null, n: 0, selected: [], filter: 'all', query: '' };
    var lastFocus = null;

    // ---- helpers --------------------------------------------------------
    function money(cents) {
      var r = Math.round(cents) / 100;
      return '₹' + r.toLocaleString('en-IN');
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function normGender(g) { return (g || '').trim(); }

    /* Count how many times a perfume is currently in the box — the basis of
       every selection/render decision below. Repeat picks of the same
       perfume are allowed (2026-09-10, BB: "if someone wants to add 2
       perfume of same item then quantity should increase"), so `selected`
       is a plain array that may hold the same title more than once; it is
       never deduplicated. */
    function countOf(title) {
      var c = 0;
      for (var i = 0; i < state.selected.length; i++) {
        if (state.selected[i] === title) c++;
      }
      return c;
    }

    // distinct genders present in the pool, in a stable order
    var GENDERS = (function () {
      var order = ['For Him', 'For Her', 'Unisex'];
      var seen = {};
      PRODUCTS.forEach(function (p) { var g = normGender(p.gender); if (g) seen[g] = true; });
      var list = [];
      order.forEach(function (g) { if (seen[g]) { list.push(g); delete seen[g]; } });
      Object.keys(seen).forEach(function (g) { list.push(g); });
      return list;
    })();

    // ---- rendering ------------------------------------------------------
    function renderFilters() {
      var html = '<button type="button" class="tss-cb-chip is-active" data-filter="all" aria-pressed="true">All</button>';
      GENDERS.forEach(function (g) {
        html += '<button type="button" class="tss-cb-chip" data-filter="' + esc(g) + '" aria-pressed="false">' + esc(g) + '</button>';
      });
      filterEl.innerHTML = html;
    }

    function visibleProducts() {
      var q = state.query.trim().toLowerCase();
      return PRODUCTS.filter(function (p) {
        if (state.filter !== 'all' && normGender(p.gender) !== state.filter) return false;
        if (q) {
          var hay = (p.title + ' ' + (p.inspired || '')).toLowerCase();
          if (hay.indexOf(q) === -1) return false;
        }
        return true;
      });
    }

    function renderGrid() {
      var list = visibleProducts();
      if (!list.length) {
        gridEl.innerHTML = '';
        emptyEl.hidden = false;
        return;
      }
      emptyEl.hidden = true;
      var atMax = state.selected.length >= state.n;
      var html = '';
      list.forEach(function (p) {
        var c = countOf(p.title);
        var sel = c > 0;
        /* At max capacity, an UNselected card locks (no room left); a card
           already in the box stays clickable so tapping it removes one
           instance and frees a slot — the same tap target doubles as
           "add" (below capacity) and "remove one" (at capacity). */
        var disabled = (!sel && atMax);
        var cls = 'tss-cb-card' + (sel ? ' is-selected' : '') + (disabled ? ' is-disabled' : '');
        var sub = p.gender ? esc(p.gender) : '';
        if (p.inspired) { sub = (sub ? sub + ' · ' : '') + esc(p.inspired); }
        html += '<button type="button" class="' + cls + '" ' +
          'data-title="' + esc(p.title) + '" ' +
          'data-price="' + p.price + '" ' +
          'aria-pressed="' + (sel ? 'true' : 'false') + '"' +
          (disabled ? ' aria-disabled="true"' : '') + '>' +
          '<span class="tss-cb-card__tick" aria-hidden="true"></span>' +
          (c > 1 ? '<span class="tss-cb-card__count" aria-hidden="true">×' + c + '</span>' : '') +
          (p.img ? '<img class="tss-cb-card__img" src="' + esc(p.img) + '" alt="" loading="lazy" width="120" height="120">' :
            '<span class="tss-cb-card__img tss-cb-card__img--ph" aria-hidden="true"></span>') +
          '<span class="tss-cb-card__name">' + esc(p.title) + (c > 1 ? ' <span class="tss-cb-card__name-count">(' + c + ')</span>' : '') + '</span>' +
          (sub ? '<span class="tss-cb-card__sub">' + sub + '</span>' : '') +
          '<span class="tss-cb-card__price">' + money(p.price) + '</span>' +
          '</button>';
      });
      gridEl.innerHTML = html;
    }

    function renderStatus() {
      var picked = state.selected.length;
      countEl.textContent = picked + ' of ' + state.n + ' selected';
      var comboPrice = MODES[state.mode].price;
      var indiv = 0;
      state.selected.forEach(function (t) {
        var p = findProduct(t); if (p) indiv += p.price;
      });
      var complete = picked === state.n;
      var parts = [];
      parts.push('Pack price <strong>' + money(comboPrice) + '</strong>');
      if (complete && indiv > 0) {
        parts.push('these ' + state.n + ' bottles individually ' + money(indiv));
        var save = indiv - comboPrice;
        if (save > 0) parts.push('<span class="tss-cb-save">you save ' + money(save) + '</span>');
      }
      priceLineEl.innerHTML = parts.join(' · ');
      addBtn.disabled = !complete;
      addBtn.textContent = complete
        ? 'Add pack to cart — ' + money(comboPrice)
        : 'Pick ' + (state.n - picked) + ' more';
    }

    function findProduct(title) {
      for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].title === title) return PRODUCTS[i];
      return null;
    }

    function renderAll() { renderGrid(); renderStatus(); }

    // ---- selection ------------------------------------------------------
    /* Below capacity: every click (whether the perfume is already in the box
       or not) adds ONE MORE unit of that perfume, up to the pack size — so
       clicking the same card twice puts 2 of that scent in the box. At
       capacity: clicking a card already in the box removes ONE unit,
       freeing a slot; clicking anything else does nothing (those cards are
       rendered disabled, see renderGrid). */
    function toggle(title) {
      var atMax = state.selected.length >= state.n;
      if (atMax) {
        var idx = state.selected.indexOf(title);
        if (idx !== -1) state.selected.splice(idx, 1);
        else return;
      } else {
        state.selected.push(title);
      }
      renderAll();
    }

    // ---- modal ----------------------------------------------------------
    function openModal(mode) {
      var m = MODES[mode];
      if (!m) return;
      state.mode = mode; state.n = m.n; state.selected = []; state.filter = 'all'; state.query = '';
      if (searchEl) searchEl.value = '';
      titleEl.textContent = m.title;
      subEl.textContent = 'Pick exactly ' + m.n + ' fragrances · pack price ' + money(m.price);
      errEl.hidden = true;
      renderFilters();
      renderAll();
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('tss-cb-lock');
      document.addEventListener('keydown', onKey, true);
      var f = modal.querySelector('[data-combo-close]');
      if (f) f.focus();
    }
    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('tss-cb-lock');
      document.removeEventListener('keydown', onKey, true);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      if (e.key === 'Tab') { trapTab(e); }
    }
    function trapTab(e) {
      var f = modal.querySelectorAll('button:not([disabled]), input, [href], [tabindex]:not([tabindex="-1"])');
      var vis = [];
      for (var i = 0; i < f.length; i++) { if (f[i].offsetParent !== null || f[i] === document.activeElement) vis.push(f[i]); }
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    // ---- add to cart ----------------------------------------------------
    function addToCart() {
      if (state.selected.length !== state.n) return;
      var m = MODES[state.mode];
      var props = {};
      /* Duplicates are already correctly reflected here — each occurrence in
         `state.selected` (including repeats of the same perfume) becomes its
         own "Perfume N" property, so a box with 2 of one scent lists it
         twice in order. */
      state.selected.forEach(function (t, i) { props['Perfume ' + (i + 1)] = t; });
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      errEl.hidden = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(m.variant), quantity: 1, properties: props }] })
      }).then(function (r) {
        if (!r.ok) { return r.json().then(function (j) { throw new Error(j && j.description ? j.description : 'Could not add to cart.'); }); }
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function (err) {
        errEl.textContent = err && err.message ? err.message : 'Could not add to cart. Please try again.';
        errEl.hidden = false;
        renderStatus();
      });
    }

    // ---- events (delegated) --------------------------------------------
    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-combo-open]');
      if (open) { e.preventDefault(); openModal(open.getAttribute('data-combo-open')); return; }
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-combo-close]') || e.target.hasAttribute('data-combo-backdrop')) { closeModal(); return; }
      var chip = e.target.closest('[data-filter]');
      if (chip) {
        state.filter = chip.getAttribute('data-filter');
        filterEl.querySelectorAll('.tss-cb-chip').forEach(function (c) {
          var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        renderGrid(); return;
      }
      var card = e.target.closest('.tss-cb-card');
      if (card) {
        if (card.getAttribute('aria-disabled') === 'true') return;
        toggle(card.getAttribute('data-title')); return;
      }
      if (e.target.closest('[data-combo-add]')) { addToCart(); return; }
    });

    if (searchEl) {
      searchEl.addEventListener('input', function () { state.query = searchEl.value || ''; renderGrid(); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
